export const IconCamera = () => {
    return (
        <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <defs>
                <clipPath id='clip602_37960'>
                    <rect id='All/Camera' width='32' height='32' fill='white' fillOpacity='0' />
                </clipPath>
            </defs>
            <g clipPath='url(#clip602_37960)'>
                <path
                    id='Vector'
                    d='M15.99 20.63C17.05 20.63 17.96 20.26 18.7 19.51C19.45 18.77 19.83 17.87 19.83 16.8C19.83 15.74 19.45 14.84 18.7 14.09C17.96 13.34 17.05 12.96 15.99 12.96C14.92 12.96 14.02 13.34 13.28 14.09C12.53 14.84 12.16 15.74 12.16 16.8C12.16 17.87 12.53 18.77 13.28 19.51C14.02 20.26 14.92 20.63 15.99 20.63ZM15.99 18.29C15.56 18.29 15.21 18.15 14.93 17.86C14.64 17.58 14.5 17.23 14.5 16.8C14.5 16.38 14.64 16.02 14.93 15.74C15.21 15.45 15.56 15.3 15.99 15.3C16.41 15.3 16.77 15.44 17.05 15.73C17.34 16.02 17.49 16.37 17.49 16.8C17.49 17.23 17.35 17.58 17.06 17.86C16.77 18.15 16.42 18.29 15.99 18.29ZM9.74 24.18C8.97 24.18 8.32 23.92 7.79 23.38C7.26 22.85 7 22.2 7 21.44L7 12.15C7 11.39 7.26 10.74 7.79 10.21C8.32 9.67 8.97 9.41 9.74 9.41L11.64 9.41L13.47 7.8L18.52 7.8L20.35 9.41L22.25 9.41C23.02 9.41 23.67 9.67 24.2 10.21C24.73 10.74 25 11.39 25 12.15L25 21.44C25 22.2 24.73 22.85 24.2 23.38C23.67 23.92 23.02 24.18 22.25 24.18L9.74 24.18Z'
                    fill='#FFFFFF'
                    fillOpacity='1'
                    fillRule='evenodd'
                />
            </g>
        </svg>
    );
};
